import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Select } from '@/components/ui/select'

export type BatchFormData = {
  code: string
  year: number | ''
  period: 1 | 2 | ''
}

type BatchFormFieldsProps<T extends BatchFormData> = {
  data: T
  errors: Partial<Record<keyof T, string>>
  setData: <K extends keyof T>(key: K, value: T[K]) => void
}

export function BatchFormFields<T extends BatchFormData>({
  data,
  errors,
  setData,
}: BatchFormFieldsProps<T>) {
  const err = (key: keyof T) => errors[key]

  return (
    <Card>
      <CardHeader>
        <CardTitle>Batch</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-5 sm:grid-cols-[1fr_140px_160px]">
        <div className="space-y-1.5">
          <Label htmlFor="code">Code</Label>
          <Input
            id="code"
            value={data.code}
            autoFocus
            placeholder="e.g. 26-I"
            onChange={(e) => setData('code' as keyof T, e.target.value as T[keyof T])}
          />
          {err('code' as keyof T) && (
            <p className="text-xs text-destructive">{err('code' as keyof T)}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="year">Year</Label>
          <Input
            id="year"
            type="number"
            min={2020}
            max={2100}
            value={data.year === '' ? '' : data.year}
            onChange={(e) => {
              const v = e.target.value
              setData('year' as keyof T, (v === '' ? '' : Number(v)) as T[keyof T])
            }}
          />
          {err('year' as keyof T) && (
            <p className="text-xs text-destructive">{err('year' as keyof T)}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="period">Period</Label>
          <Select
            id="period"
            value={data.period === '' ? '' : String(data.period)}
            onChange={(e) => {
              const v = e.target.value
              setData('period' as keyof T, (v === '' ? '' : Number(v)) as T[keyof T])
            }}
          >
            <option value="">Select…</option>
            <option value="1">I (first half)</option>
            <option value="2">II (second half)</option>
          </Select>
          {err('period' as keyof T) && (
            <p className="text-xs text-destructive">{err('period' as keyof T)}</p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
